var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 2.6,
    width: 22.7308,
    height: 25.8,
    rx: 4.4,
    stroke: "#003032",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4602 13.0215C13.6072 13.475 14.0294 13.782 14.5061 13.7822H17.7346L15.1204 15.6865C14.7359 15.9666 14.5753 16.4625 14.7219 16.915L15.718 19.9941L13.1116 18.0947L12.9612 18.002C12.6492 17.8437 12.2791 17.8438 11.967 18.002L11.8167 18.0947L9.20728 19.9951L10.2063 16.915C10.3529 16.4625 10.1923 15.9666 9.80786 15.6865L7.1936 13.7822H10.4211C10.898 13.7822 11.321 13.4752 11.468 13.0215L12.4631 9.94629L13.4602 13.0215Z",
    stroke: "#003032",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.58267,
    y: 0.6,
    width: 10.7654,
    height: 3.8,
    rx: 1.4,
    fill: "#EFEFE9",
    stroke: "#003032",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsNew);
export default __webpack_public_path__ + "static/media/Results_new.30e9eb9a31cb59f28867da9db5a35f4e.svg";
export { ForwardRef as ReactComponent };